import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import FilterButton from './FilterButton';
import FilterBody from './FilterBody';
import * as filterActions from '../actions';

class Filter extends Component {
    componentDidMount() {
        this.props.onMount();
        document.addEventListener('click', this.handleClickOutside.bind(this), true);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, true);
    }

    handleClickOutside(event) {
        if (!this.props.opened) {
            return;
        }

        const domNode = this.node.getElementsByClassName('ui-filter')[0];
        const filterBtn = this.node.getElementsByClassName('sales__filterBtn')[0];

        if (!domNode.contains(event.target) && !filterBtn.contains(event.target)) {
            this.props.onCancelClick();
        }
    }

    render() {
        return (
            <div
                className={`pp-filter__wrapper sales__filter ${this.props.cssClass}`}
                ref={node => (this.node = node)}
            >
                <FilterButton onButtonClick={this.props.onButtonClick}>
                    Filter
                </FilterButton>
                <FilterBody {...this.props} />
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const { parameters, hiddenParams, defaults,
        title, opened, expanded,
        selection, url } = _.get(state, `${ownProps.stateKey}.filter`, {});

    return {
        parameters,
        hiddenParams,
        defaults,
        title,
        opened,
        expanded,
        selection,
        url
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        onMount: () => {
            if (ownProps.onBeforeInit) {
                dispatch(ownProps.onBeforeInit());
            }

            if (ownProps.config.url) {
                dispatch(filterActions.fetchConfig(
                    ownProps.stateKey,
                    ownProps.config.url,
                    ownProps.config,
                    ownProps.onAfterInit
                ));
            } else {
                dispatch(filterActions.init(
                    ownProps.stateKey,
                    ownProps.config,
                    ownProps.onAfterInit
                ));
            }
        },
        onOptionSelect: (name, value) => dispatch(
            filterActions.selectOption(ownProps.stateKey, name, value)
        ),
        onParameterExpand: name => dispatch(
            filterActions.toggleParameter(ownProps.stateKey, name)
        ),
        onButtonClick: () => dispatch(
            filterActions.toggleFilter(ownProps.stateKey)
        ),
        onCancelClick: () => dispatch(
            filterActions.closeFilter(ownProps.stateKey)
        ),
        onApplyClick: () => dispatch(
            filterActions.applyFilter(ownProps.stateKey, ownProps.onApply)
        )
    };
}

Filter.propTypes = {
    // own props
    config: PropTypes.object.isRequired,
    stateKey: PropTypes.string.isRequired,
    cssClass: PropTypes.string,
    onBeforeInit: PropTypes.func,
    onAfterInit: PropTypes.func,
    onApply: PropTypes.func,

    // state props
    parameters: PropTypes.array,
    hiddenParams: PropTypes.array,
    defaults: PropTypes.object,
    title: PropTypes.string,
    opened: PropTypes.bool,
    expanded: PropTypes.array,
    selection: PropTypes.object,
    url: PropTypes.string,

    // dispatch props
    onMount: PropTypes.func,
    onOptionSelect: PropTypes.func,
    onParameterExpand: PropTypes.func,
    onButtonClick: PropTypes.func,
    onCancelClick: PropTypes.func,
    onRequest: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(Filter);



// WEBPACK FOOTER //
// ./src/js/modules/Filter/components/index.js